import { bl_sfa_sales_group_hdr_RowClass } from '../../../dbschema/bl_sfa_sales_group_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class SfaSalesGroupContainerModel extends BaseContainerModel {
    bl_sfa_sales_group_hdr: bl_sfa_sales_group_hdr_RowClass = new bl_sfa_sales_group_hdr_RowClass();
}
